// src/components/Speakers.js
import React from 'react';

const articles = [
  {
    title: "Tough Measures Await Employers Defaulting Occupational Health and Safety",
    link: "https://www.ktpress.rw/2024/10/tough-measures-await-employers-defaulting-occupational-health-and-safety/",
    newspaper: "KT Press"
  },
  {
    title: "Abafite Ibigo Basabwe Gushyira Imbere Ubuzima Numutekano Byumukozi Kuruta Inyungu",
    link: "https://umuseke.rw/2024/10/abafite-ibigo-basabwe-gushyira-imbere-ubuzima-numutekano-byumukozi-kuruta-inyungu/",
    newspaper: "Umuseke"
  },
  {
    title: "Rwanda's Commitment to Worker Safety: Reflections from the OHS Conference 2024",
    link: "https://www.topafricanews.com/2024/10/26/rwandas-commitment-to-worker-safety-reflections-from-the-ohs-conference-2024/",
    newspaper: "Top Africa News"
  },
  {
    title: "Govt Orders Employers to Set Safety Committees to Curb Occupational Hazards",
    link: "https://www.newtimes.co.rw/article/21342/news/rwanda/govt-orders-employers-to-set-safety-committees-to-curb-occupational-hazards",
    newspaper: "New Times"
  },
  {
    title: "Asaga Miliyari 3.7 FRW Yishyuwe n'Ubwishingizi mu Mwaka Itatu Bitewe n'Impanuka",
    link: "https://mobile.igihe.com/amakuru/u-rwanda/article/asaga-miliyari-3-7-frw-yishyuwe-n-ubwishingizi-mu-myaka-itatu-bitewe-n-impanuka",
    newspaper: "Igihe"
  }
];

export default function NewsArticles() {
  return (
    <div className="p-8 mt-28 bg-gray-100">
      <h2 className="text-4xl font-maiandra text-center text-gray-800 mb-8">Latest News Articles</h2>
      <div className="flex justify-center">
        <div className="grid md:w-[80%] w-[90%] grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 transition-transform transform hover:shadow-xl hover:scale-105">
              <h3 className="text-lg font-semibold mb-3">
                <a
                  href={article.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:text-blue-700"
                >
                  {article.title}
                </a>
              </h3>
              <p className="text-gray-600 text-sm mb-4">Published by: <span className="font-medium">{article.newspaper}</span></p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
